import {editProfileBrowserSettings} from '@/http/requests/profile'
import $ from 'jquery'
import Vue from 'vue'
import {getReadingTime} from '@/prototypes/u/other'

const $t = sign => Vue.prototype.i18n.t(sign)

export default {

  // get user browser settings
  SET_USER_BROWSER_SETTING (state, payload) {
    // state.tables = payload || {}
    // state.tables = {
    //   ...state.tables,
    //   payload: payload.tables
    // }
    state.tables = $.extend(state.tables, payload.tables)

    // delete state.tables.payload
  },

  SET_TABLE_SETTING (state, payload) {
    const tableId = payload.id
    delete payload.id

    if (!state.tables[tableId]) state.tables[tableId] = {}

    if (payload.headers) {
      const headers = []
      payload.headers.forEach((header) => {
        headers.push({
          field: header.field,
          filterDefault: header.filterDefault || null,
          show: !header.hasOwnProperty('show') || header.show
        })
      })
      state.tables[tableId] = {rtl: payload.rtl, headers}
    }
  },

  UPDATE_USER_BROWSER_SETTINGS (state, payload) {
    editProfileBrowserSettings({}).then(() => {
      if (payload && payload.showNotification) {
        Vue.prototype.$vs.notify({
          title: $t('others.alert.message.title'),
          text: $t('others.alert.message.saveChange'),
          icon: 'icon-check',
          iconPack: 'feather',
          time: getReadingTime($t('others.alert.message.saveChange')),
          color: 'success'
        })
      }
    }).catch(e => {
      console.log(e)
    })
  }
}
